import React from 'react';
import { GlobalButtonProps } from 'models';
import styles from './button.module.scss';

const Button: React.FC<GlobalButtonProps> = ({ 
  type, 
  label, 
  onClick, 
  disabled,
  style
}) => {
  return (
    <>
      {type === 'contained' && (
        <button 
          className={styles.primaryButton} 
          onClick={onClick} 
          disabled={disabled}
          style={style}
        >
          {label}
        </button>
      )}
      {type === 'outlined' && (
        <button 
          className={styles.outlinedButton} 
          onClick={onClick} 
          disabled={disabled}
          style={style}
        >
          {label}
        </button>
      )}
    </>
  );
};

export default Button;
